<template>
  <section>
    {{ $t('social-sharing-button-toolbar.label.share') }}：
    <b-button-group size="sm">
      <ShareNetwork
        network="facebook"
        :url="resolved_url"
        :title="title"
        :description="description"
        :quote="title"
        class="btn btn-link text-primary"
      >
        <font-awesome-icon icon="fa-brands fa-facebook-square" size="3x"></font-awesome-icon>
      </ShareNetwork>
      <ShareNetwork
        network="line"
        :url="resolved_url.includes('?') ? `${resolved_url}&openExternalBrowser=1` : `${resolved_url}?openExternalBrowser=1`"
        :title="title"
        :description="description"
        class="btn btn-link text-success"
      >
        <font-awesome-icon icon="fa-brands fa-line" size="3x"></font-awesome-icon>
      </ShareNetwork>
      <button type="button" class="btn btn-link text-warning" @click="copyUrlToClipboard">
        <font-awesome-icon icon="fa-solid fa-link" size="2x"></font-awesome-icon>
      </button>
    </b-button-group>
  </section>
</template>

<script>
import Vue from 'vue'

import VueSocialSharing from 'vue-social-sharing'

import { ButtonGroupPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { Toast } from 'vant'

/* add fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/* import specific icons */
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons'
import { faLine } from '@fortawesome/free-brands-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'

import i18n from '@/plugins/i18n.js'

/* add icons to the library */
library.add(faFacebookSquare)
library.add(faLine)
library.add(faLink)

Vue.use(ButtonGroupPlugin)
Vue.use(IconsPlugin)
Vue.use(VueSocialSharing)
Vue.use(Toast)

export default {
  i18n,
  name: 'social-sharing-button-toolbar',
  props: {
    to: {
      type: [String, Object],
      require: true
    },
    title: {
      type: String,
      require: true
    },
    description: {
      type: String,
      require: true
    }
  },
  computed: {
    resolved_url() {
      if (typeof this.to === 'string') {
        return this.to
      }
      const route = this.$router.resolve(this.to)
      return `${window.location.origin}${route.href}`
    }
  },
  methods: {
    copyUrlToClipboard() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.resolved_url)
        Toast.success('複製成功')
      } else {
        Toast.fail('您的瀏覽器不支援此功能')
      }
    }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    FontAwesomeIcon
  }  
}
</script>